/* VaVoom Fit Assistant V43 — deterministic multi-dimensional ensemble engine
   No AI. No ML. No store-size guessing.
*/
(function () {
  if (window.__VAVOOM_FIT_V43__) return;
  window.__VAVOOM_FIT_V43__ = true;

  const VERSION = 'V43_ENSEMBLE';
  const CFG = window.VaVoomFitConfig || {};
  const SIZE_ORDER = CFG.sizeOrder || ['XXS','XS','S','M','L','XL','2XL','3XL','4XL'];
  const PRIMARY_STORAGE_KEY = 'vavoom_fit_profile_v43';
  const COMPAT_KEYS = [
    PRIMARY_STORAGE_KEY,
    'vavoom_fit_profile_v42',
    'vavoom_fit_profile_v39',
    'vavoom_fit_profile',
    'vavoom_fit_profile_v38',
    'vavoom_fit_profile_v37'
  ];

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const num = (v) => {
    const n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(n) ? n : null;
  };
  const norm = (v) => String(v || '')
    .toLowerCase().replace(/\u00a0/g, ' ').replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ').trim();

  function normalizeSize(v) {
    let s = String(v || '').trim().toUpperCase().replace(/\s+/g, '').replace(/-/g, '');
    if (['XXL','2X','2XLARGE'].includes(s)) s = '2XL';
    if (['XXXL','3X','3XLARGE'].includes(s)) s = '3XL';
    if (['XXXXL','4X','4XLARGE'].includes(s)) s = '4XL';
    if (s === 'EXTRASMALL') s = 'XS';
    if (s === 'SMALL') s = 'S';
    if (s === 'MEDIUM') s = 'M';
    if (s === 'LARGE') s = 'L';
    if (s === 'EXTRALARGE') s = 'XL';
    return SIZE_ORDER.includes(s) ? s : '';
  }

  function heightToInches(v) {
    const raw = String(v || '').trim();
    if (!raw) return null;
    if (raw.includes("'")) {
      const parts = raw.split("'");
      const feet = parseFloat(parts[0]);
      const inches = parseFloat(parts[1] || '0');
      if (!Number.isFinite(feet)) return null;
      return feet * 12 + (Number.isFinite(inches) ? inches : 0);
    }
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 48 && n < 96 ? n : null;
  }

  function formatHeight(v) {
    const h = heightToInches(v);
    if (!Number.isFinite(h)) return String(v || '').trim();
    const feet = Math.floor(h / 12);
    const inches = Math.round((h - feet * 12) * 10) / 10;
    return `${feet}'${inches}`;
  }

  function value(profile, keys) {
    for (const key of keys) {
      if (profile && profile[key] != null && String(profile[key]).trim() !== '') return profile[key];
    }
    return '';
  }

  function migrateProfile(raw, source) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    const p = Object.assign({}, raw.profile && typeof raw.profile === 'object' ? raw.profile : raw);
    if (!p.gender) p.gender = p.sex || '';
    if (!p.chest) p.chest = p.bust || p.full_bust || '';
    if (!p.shoulder_width) p.shoulder_width = p.shoulders || '';
    if (!p.hips) p.hips = p.hip || '';
    if (!p.torso_center_back) p.torso_center_back = p.torso_length || p.torso || '';

    // Recover the legacy 20" anatomical torso value only when it is clearly torso-like.
    if (!p.torso_center_back) {
      const oldTop = num(p.preferred_top_length || p.top_length);
      if (Number.isFinite(oldTop) && oldTop >= 15 && oldTop <= 24.5) {
        p.torso_center_back = String(oldTop);
      }
    }

    delete p.preferred_top_length;
    delete p.top_length;
    p.profile_version = 'v43_anatomical_ensemble';
    p.__source = source || 'unknown';
    return p;
  }

  function parseStored(raw, source) {
    if (!raw) return null;
    try { return migrateProfile(JSON.parse(raw), source); }
    catch (e) { return null; }
  }

  function readBrowserProfile() {
    for (const key of COMPAT_KEYS) {
      try {
        const p = parseStored(localStorage.getItem(key), `localStorage:${key}`);
        if (p) return p;
      } catch (e) {}
      try {
        const p = parseStored(sessionStorage.getItem(key), `sessionStorage:${key}`);
        if (p) return p;
      } catch (e) {}
    }
    return null;
  }

  function writeBrowserProfile(profile) {
    const clean = Object.assign({}, profile);
    delete clean.__source;
    const raw = JSON.stringify(clean);
    [PRIMARY_STORAGE_KEY, 'vavoom_fit_profile'].forEach((key) => {
      try { localStorage.setItem(key, raw); } catch (e) {}
      try { sessionStorage.setItem(key, raw); } catch (e) {}
    });
  }

  function saveCartProfile(profile) {
    const clean = Object.assign({}, profile);
    delete clean.__source;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({
        attributes: {
          vavoom_fit_profile_v43: JSON.stringify(clean),
          vavoom_fit_profile: JSON.stringify(clean),
          vavoom_fit_profile_updated_at: clean.updated_at || new Date().toISOString()
        }
      })
    }).then(r => r.ok).catch(() => false);
  }

  function readCartProfile() {
    return fetch('/cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
      .then(r => r.ok ? r.json() : null)
      .then(cart => {
        const a = cart && cart.attributes || {};
        for (const key of ['vavoom_fit_profile_v43','vavoom_fit_profile','vavoom_fit_profile_v39']) {
          const p = parseStored(a[key], `cart:${key}`);
          if (p) {
            writeBrowserProfile(p);
            return p;
          }
        }
        return null;
      })
      .catch(() => null);
  }

  function initProfileForm() {
    const form = document.getElementById('VavoomFitProfileForm');
    if (!form || form.dataset.vavoomReady === VERSION) return;
    form.dataset.vavoomReady = VERSION;

    const message = document.getElementById('FitProfileMessage');
    const updated = document.getElementById('FitProfileUpdated');
    const percent = document.getElementById('FitProfilePercent');
    const bar = document.getElementById('FitProfileBar');
    const hint = document.getElementById('FitProfileHint');
    const names = ['chest','shoulder_width','torso_center_back','waist','hips','inseam','thigh'];

    const fieldValue = (name) => {
      if (name === 'gender') return form.querySelector('[name="gender"]:checked')?.value || '';
      return form.elements[name] ? String(form.elements[name].value || '').trim() : '';
    };

    function strength() {
      let n = 0;
      if (fieldValue('chest')) n += 24;
      if (fieldValue('shoulder_width')) n += 16;
      if (fieldValue('torso_center_back')) n += 14;
      if (fieldValue('waist')) n += 14;
      if (fieldValue('hips')) n += 14;
      if (fieldValue('inseam')) n += 8;
      if (fieldValue('thigh')) n += 5;
      if (fieldValue('height')) n += 4;
      if (fieldValue('gender')) n += 1;
      return clamp(n, 0, 100);
    }

    function refresh() {
      const s = strength();
      if (percent) percent.textContent = `${s}%`;
      if (bar) bar.style.width = `${s}%`;
      if (!hint) return;
      if (!fieldValue('chest') && !(fieldValue('waist') && fieldValue('hips'))) {
        hint.textContent = 'Add chest for tops or waist and hips for bottoms.';
      } else if (fieldValue('chest') && !fieldValue('shoulder_width')) {
        hint.textContent = 'Shoulder Width improves drape calculations.';
      } else if (fieldValue('chest') && !fieldValue('torso_center_back')) {
        hint.textContent = 'Torso Center Back improves vertical-proportion checks.';
      } else {
        hint.textContent = 'Direct body measurements are used first.';
      }
    }

    function load(p) {
      if (!p) return;
      ['height','chest','shoulder_width','torso_center_back','waist','hips','inseam','thigh'].forEach(name => {
        if (form.elements[name] && p[name] != null) form.elements[name].value = p[name];
      });
      if (p.gender) {
        const radio = form.querySelector(`[name="gender"][value="${p.gender}"]`);
        if (radio) radio.checked = true;
      }
      if (updated && p.updated_at) {
        const d = new Date(p.updated_at);
        if (!Number.isNaN(d.getTime())) updated.textContent = `Last updated: ${d.toLocaleString()}`;
      }
      refresh();
    }

    names.forEach(name => {
      const el = form.elements[name];
      if (!el) return;
      el.addEventListener('input', () => {
        el.value = String(el.value || '').replace(/[^0-9.]/g,'').replace(/(\..*)\./g,'$1').slice(0,5);
        el.classList.remove('fit-error');
        refresh();
      });
    });

    if (form.elements.height) {
      form.elements.height.addEventListener('blur', () => {
        form.elements.height.value = formatHeight(form.elements.height.value);
        refresh();
      });
    }

    form.addEventListener('change', refresh);
    const initial = readBrowserProfile();
    if (initial) load(initial);
    else readCartProfile().then(load);

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (message) message.textContent = '';

      const ranges = {
        chest:[24,80], shoulder_width:[10,32], torso_center_back:[12,35],
        waist:[18,80], hips:[24,90], inseam:[15,45], thigh:[12,45]
      };
      let invalid = false;

      for (const [name, range] of Object.entries(ranges)) {
        const el = form.elements[name];
        if (!el || !String(el.value).trim()) continue;
        const n = num(el.value);
        const ok = Number.isFinite(n) && n >= range[0] && n <= range[1];
        el.classList.toggle('fit-error', !ok);
        if (!ok) invalid = true;
      }

      if (!fieldValue('chest') && !(fieldValue('waist') && fieldValue('hips'))) invalid = true;
      if (invalid) {
        if (message) message.textContent = 'Check the highlighted measurements.';
        return;
      }

      const profile = {
        profile_version:'v43_anatomical_ensemble',
        customer_id:form.dataset.customerId || '',
        gender:fieldValue('gender'),
        height:fieldValue('height'),
        chest:fieldValue('chest'),
        shoulder_width:fieldValue('shoulder_width'),
        torso_center_back:fieldValue('torso_center_back'),
        waist:fieldValue('waist'),
        hips:fieldValue('hips'),
        inseam:fieldValue('inseam'),
        thigh:fieldValue('thigh'),
        updated_at:new Date().toISOString()
      };

      writeBrowserProfile(profile);
      saveCartProfile(profile);
      if (message) message.textContent = 'Fit Profile saved.';
      if (updated) updated.textContent = `Last updated: ${new Date(profile.updated_at).toLocaleString()}`;
      refresh();
      try { window.dispatchEvent(new CustomEvent('vavoom:fit-profile-saved', {detail:profile})); } catch(e) {}
    });

    refresh();
  }

  function descriptionText(root) {
    const t = root.querySelector('[data-vavoom-product-description]');
    return t?.content ? String(t.content.textContent || '') : '';
  }

  function getMeta(root) {
    return {
      id:root.dataset.productId || '',
      title:root.dataset.productTitle || '',
      type:root.dataset.productType || '',
      vendor:root.dataset.productVendor || '',
      tags:root.dataset.productTags || '',
      collections:root.dataset.productCollections || '',
      categoryOverride:root.dataset.fitCategoryOverride || '',
      fitOverride:root.dataset.fitIntentOverride || '',
      description:descriptionText(root)
    };
  }

  function categoryFromMeta(m) {
    const override = norm(m.categoryOverride);
    const allowed = ['tee','shirt','hoodie','sweatshirt','jacket','tank','shorts','sweatpants','jeans','pants','top'];
    if (allowed.includes(override)) return {category:override, source:'metafield'};

    const text = norm([m.type,m.collections,m.title,m.description].join(' '));
    if (/\bjeans?\b/.test(text)) return {category:'jeans', source:'text'};
    if (text.includes('sweatpants') || text.includes('sweat pants') || text.includes('jogger')) return {category:'sweatpants', source:'text'};
    if (text.includes('shorts') || text.includes('skort')) return {category:'shorts', source:'text'};
    if (text.includes('hoodie') || text.includes('hoodies')) return {category:'hoodie', source:'text'};
    if (text.includes('sweatshirt') || text.includes('sweatshirts') || text.includes('crewneck sweatshirt')) return {category:'sweatshirt', source:'text'};
    if (text.includes('jacket') || text.includes('coat') || text.includes('windbreaker') || text.includes('shacket')) return {category:'jacket', source:'text'};
    if (text.includes('tank')) return {category:'tank', source:'text'};
    if (text.includes('t-shirt') || text.includes('t shirt') || /\btee\b/.test(text)) return {category:'tee', source:'text'};
    if (text.includes('shirt')) return {category:'shirt', source:'text'};
    if (text.includes('pants') || text.includes('trouser') || text.includes('cargo')) return {category:'pants', source:'text'};
    return {category:'top', source:'fallback'};
  }

  function detectShapes(m) {
    const t = norm([m.title,m.description,m.type,m.collections].join(' '));
    return {
      boxy:/\bbox(y|ier)\b/.test(t),
      dropShoulder:t.includes('drop shoulder') || t.includes('drop-shoulder') || t.includes('dropped shoulder'),
      cropped:t.includes('cropped') || t.includes('crop top') || t.includes('crop tee'),
      wideLeg:t.includes('wide leg') || t.includes('wide-leg') || t.includes('barrel leg') || t.includes('barrel-leg'),
      adjustableWaist:t.includes('drawstring') || t.includes('drawcord') || t.includes('elastic waist') || t.includes('elastic waistband') || t.includes('elasticated'),
      stretch:t.includes('spandex') || t.includes('elastane') || t.includes('lycra') || t.includes('stretch'),
      nonStretch:t.includes('non-stretch') || t.includes('non stretch') || t.includes('100% cotton') || t.includes('denim'),
      thick:t.includes('thick') || t.includes('heavyweight') || /\b4\d\d\s?gsm\b/.test(t)
    };
  }

  function normalizeFit(raw) {
    const t = norm(raw);
    if (t.includes('bodycon')) return 'bodycon';
    if (t.includes('skinny') || t.includes('slim') || t.includes('fitted')) return 'slim';
    if (t.includes('oversized') || t.includes('oversize')) return 'oversized';
    if (t.includes('baggy') || t.includes('wide leg') || t.includes('barrel leg')) return 'loose';
    if (t.includes('loose')) return 'loose';
    if (t.includes('relaxed')) return 'relaxed';
    if (t.includes('regular') || t.includes('classic fit') || t.includes('standard fit')) return 'regular';
    return 'neutral';
  }

  function fitEvidence(m, category) {
    const C = CFG.evidenceConfidence || {};
    if (norm(m.fitOverride)) return {fit:normalizeFit(m.fitOverride),confidence:C.metafield ?? 1,source:'metafield'};

    const title = norm(m.title);
    const desc = norm(m.description);
    const structured = desc.match(/\bfit\s*[:\-]\s*(bodycon|skinny|slim|fitted|regular|loose|relaxed|baggy|oversized|wide leg|barrel leg)\b/i);
    if (structured) return {fit:normalizeFit(structured[1]),confidence:C.structuredFit ?? .95,source:'structured Fit field'};

    const titleFit = title.match(/\b(bodycon|skinny|slim|fitted|regular|loose|relaxed|baggy|oversized)\s+fit\b/i)
      || title.match(/\b(oversized|bodycon|skinny|slim|baggy)\b/i);
    if (titleFit) return {fit:normalizeFit(titleFit[1]),confidence:C.titleExplicit ?? .85,source:'title'};

    const descFit = desc.match(/\b(bodycon|skinny|slim|fitted|regular|loose|relaxed|baggy|oversized)\s+(?:fit|silhouette|cut)\b/i);
    if (descFit) return {fit:normalizeFit(descFit[1]),confidence:C.descriptionExplicit ?? .70,source:'description'};

    if (desc.includes('relaxed') || desc.includes('roomy') || desc.includes('easy fit')) {
      return {fit:'relaxed',confidence:C.descriptionClue ?? .50,source:'description clue'};
    }
    if (desc.includes('loose')) return {fit:'loose',confidence:C.descriptionClue ?? .50,source:'description clue'};

    if (category === 'tee' || category === 'shirt') return {fit:'relaxed',confidence:C.categoryPrior ?? .30,source:'category prior'};
    if (category === 'sweatshirt') return {fit:'relaxed',confidence:(C.categoryPrior ?? .30)*.75,source:'weak category prior'};
    if (['pants','jeans','sweatpants'].includes(category)) return {fit:'relaxed',confidence:C.categoryPrior ?? .30,source:'category prior'};
    return {fit:'neutral',confidence:C.none ?? 0,source:'none'};
  }

  function metricFor(label) {
    const s = norm(label);
    if (s.includes('chest') || s.includes('bust')) return 'chest';
    if (s.includes('shoulder')) return 'shoulder';
    if (s.includes('sleeve')) return 'sleeve';
    if (s.includes('waist')) return 'waist';
    if (s.includes('hip') || s.includes('seat')) return 'hips';
    if (s.includes('inseam')) return 'inseam';
    if (s.includes('thigh')) return 'thigh';
    if (s.includes('rise')) return 'rise';
    if (s.includes('leg opening') || s.includes('bottom opening')) return 'leg_opening';
    if (s.includes('length') && !s.includes('sleeve')) return 'length';
    return '';
  }

  function parseTable(table) {
    const rows = [...table.querySelectorAll('tr')].map(tr =>
      [...tr.querySelectorAll('th,td')].map(td => String(td.textContent || '').trim())
    );
    if (!rows.length) return null;

    let header = null;
    for (let r = 0; r < rows.length; r++) {
      const sizes = [];
      rows[r].forEach((cell,i) => {
        const s = normalizeSize(cell);
        if (s) sizes.push({size:s,index:i});
      });
      if (sizes.length >= 2) { header = {row:r,sizes}; break; }
    }
    if (!header) return null;

    const unitText = norm(table.textContent);
    const unit = unitText.includes(' cm') || unitText.includes('centimeter') ? 'cm' : 'inch';
    const chart = {};
    header.sizes.forEach(x => chart[x.size] = {});

    rows.forEach((row,r) => {
      if (r === header.row || !row.length) return;
      const metric = metricFor(row[0]);
      if (!metric) return;
      header.sizes.forEach(x => {
        let n = num(row[x.index]);
        if (!Number.isFinite(n)) return;
        if (unit === 'cm') n /= 2.54;
        if (n > 0 && n < 120) chart[x.size][metric] = Math.round(n*100)/100;
      });
    });

    return Object.values(chart).some(r => Object.keys(r).length) ? chart : null;
  }

  function parseSizeGuide(root) {
    const t = root.querySelector('[data-vavoom-product-description]');
    const scopes = [];
    if (t?.content) scopes.push(t.content);
    scopes.push(document);
    for (const scope of scopes) {
      for (const table of [...scope.querySelectorAll('table')]) {
        const c = parseTable(table);
        if (c) return c;
      }
    }
    return null;
  }

  function mainPicker() {
    return [...document.querySelectorAll('variant-picker[data-template-product-match="true"], variant-picker[ref="mainVariantPicker"]')]
      .find(p => !p.closest('product-card') && !p.closest('quick-add-dialog')) || null;
  }

  function sizeFieldset(picker) {
    if (!picker) return null;
    return [...picker.querySelectorAll('fieldset')].find(fs => {
      const legend = norm(fs.querySelector('legend')?.textContent);
      return legend === 'size' || legend === 'sizes' ||
        [...fs.querySelectorAll('input[type="radio"]')].some(i => norm(i.name).startsWith('size'));
    }) || null;
  }

  function selectedSize(picker=mainPicker()) {
    return normalizeSize(sizeFieldset(picker)?.querySelector('input[type="radio"]:checked')?.value || '');
  }

  function availableSizes(chart) {
    const fs = sizeFieldset(mainPicker());
    const pickerSizes = fs ? [...fs.querySelectorAll('input[type="radio"]')]
      .filter(i => !i.disabled && i.dataset.optionAvailable !== 'false')
      .map(i => normalizeSize(i.value)).filter(Boolean) : [];
    const valid = pickerSizes.length ? pickerSizes : Object.keys(chart || {});
    return Object.keys(chart || {}).filter(s => valid.includes(s))
      .sort((a,b) => SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b));
  }

  function clickSize(size) {
    const fs = sizeFieldset(mainPicker());
    if (!fs) return {ok:false,reason:'Size fieldset not found'};
    const input = [...fs.querySelectorAll('input[type="radio"]')].find(i => normalizeSize(i.value) === size);
    if (!input) return {ok:false,reason:'Recommended size control not found'};
    if (input.disabled || input.dataset.optionAvailable === 'false') return {ok:false,reason:'Recommended size unavailable'};
    if (!input.checked) input.click();
    return {ok:selectedSize() === size,reason:selectedSize() === size ? 'selected' : 'click did not verify'};
  }

  async function applyVerified(root, size) {
    const attempts = [];
    for (const delay of [80,300,700,1300,2200]) {
      await new Promise(r => setTimeout(r, delay));
      if (root.dataset.vavoomUserSizeOverride === 'true') break;
      if (selectedSize() === size) {
        attempts.push({ok:true,selected:size,reason:'verified'});
      } else {
        const result = clickSize(size);
        attempts.push({ok:result.ok,selected:selectedSize(),reason:result.reason});
      }
    }
    return {ok:selectedSize() === size,selected:selectedSize(),attempts};
  }

  function watchUserOverride(root) {
    const picker = mainPicker();
    if (!picker || picker.dataset.vavoomWatch === VERSION) return;
    picker.dataset.vavoomWatch = VERSION;
    picker.addEventListener('change', e => {
      if (!e.isTrusted) return;
      if (sizeFieldset(picker)?.contains(e.target)) root.dataset.vavoomUserSizeOverride = 'true';
    }, true);
  }

  function blendRange(neutral, specific, confidence) {
    if (!specific || confidence <= 0) return Object.assign({}, neutral);
    const c = clamp(confidence,0,1);
    return {
      low:neutral.low*(1-c)+specific.low*c,
      high:neutral.high*(1-c)+specific.high*c,
      center:neutral.center*(1-c)+specific.center*c
    };
  }

  function shiftRange(r, d) {
    return {low:r.low+(d.low||0),high:r.high+(d.high||0),center:r.center+(d.center||0)};
  }

  function upperEaseRange(category, fit, confidence, shapes) {
    const table = CFG.upperEase?.[category] || CFG.upperEase?.top;
    let r = blendRange(table.neutral, table[fit] || table.neutral, confidence);
    if (shapes.boxy && fit !== 'oversized') r = shiftRange(r, CFG.shapeModifiers?.boxyChest || {low:1,high:2.5,center:1.75});
    if (shapes.thick && ['hoodie','sweatshirt','jacket'].includes(category)) r = shiftRange(r,{low:.5,high:1,center:.75});
    return r;
  }

  function shoulderRange(fit, confidence, shapes) {
    const neutral = CFG.shoulderDrop?.neutral;
    let r = blendRange(neutral, CFG.shoulderDrop?.[fit] || neutral, confidence);
    if (shapes.boxy) r = shiftRange(r, CFG.shapeModifiers?.boxyShoulder || {low:.5,high:.75,center:.75});
    if (shapes.dropShoulder) r = shiftRange(r, CFG.shapeModifiers?.dropShoulder || {low:.5,high:.9,center:.7});
    return r;
  }

  function verticalRanges(category, shapes) {
    let h = Object.assign({}, CFG.verticalHeightRatio?.[category] || CFG.verticalHeightRatio?.top);
    let t = Object.assign({}, CFG.verticalTorsoCoverage?.[category] || CFG.verticalTorsoCoverage?.top);
    if (shapes.cropped) {
      const hs = CFG.shapeModifiers?.croppedHeightShift ?? -.055;
      const ts = CFG.shapeModifiers?.croppedTorsoShift ?? -.18;
      h = {low:h.low+hs,high:h.high+hs,center:h.center+hs};
      t = {low:t.low+ts,high:t.high+ts,center:t.center+ts};
    }
    return {height:h,torso:t};
  }

  function intervalMetric(name, val, range) {
    if (!Number.isFinite(val) || !range) return null;
    const half = Math.max((range.high-range.low)/2,.01);
    const violation = val < range.low ? (range.low-val)/half : val > range.high ? (val-range.high)/half : 0;
    return {name,value:val,low:range.low,high:range.high,center:range.center,violation,centerDistance:Math.abs(val-range.center)/half};
  }

  function chooseCircumferenceMode(chart, sizes, metric, body, range) {
    const raws = sizes.map(s => num(chart[s]?.[metric])).filter(Number.isFinite);
    if (raws.length < 2 || !Number.isFinite(body)) return null;

    function evaluate(mode) {
      const ease = raws.map(x => (mode === 'double' ? x*2 : x)-body);
      const violations = ease.map(x => intervalMetric(metric,x,range)?.violation ?? 99);
      const impossible = ease.filter(x => x < -8 || x > 50).length;
      return {mode,score:Math.min(...violations)+impossible*20};
    }

    const direct = evaluate('direct');
    const doubled = evaluate('double');
    return direct.score <= doubled.score ? direct : doubled;
  }

  function summarizeCandidate(c) {
    const metrics = c.metrics.filter(Boolean);
    const v = metrics.map(m => m.violation);
    const d = metrics.map(m => m.centerDistance);
    c.violationCount = v.filter(x => x > 1e-9).length;
    c.maxViolation = v.length ? Math.max(...v) : 99;
    c.rmsViolation = v.length ? Math.sqrt(v.reduce((s,x)=>s+x*x,0)/v.length) : 99;
    c.centerRms = d.length ? Math.sqrt(d.reduce((s,x)=>s+x*x,0)/d.length) : 99;
    return c;
  }

  function sortBy(items, keys) {
    return items.slice().sort((a,b) => {
      for (const key of keys) {
        const diff = a[key]-b[key];
        if (Math.abs(diff) > 1e-9) return diff;
      }
      return SIZE_ORDER.indexOf(a.size)-SIZE_ORDER.indexOf(b.size);
    });
  }

  function ensemblePick(candidates) {
    const passing = candidates.filter(c => !c.hardFail);
    if (!passing.length) return {error:'No size passed physical-fit constraints.',candidates};

    const corridor = sortBy(passing,['violationCount','rmsViolation','centerRms'])[0];
    const minimax = sortBy(passing,['maxViolation','violationCount','centerRms'])[0];
    const minCount = Math.min(...passing.map(c => c.violationCount));
    const balance = sortBy(passing.filter(c => c.violationCount === minCount),['centerRms','maxViolation','rmsViolation'])[0];

    const votes = [corridor.size,minimax.size,balance.size];
    const counts = votes.reduce((o,s)=>(o[s]=(o[s]||0)+1,o),{});
    const majority = Object.entries(counts).sort((a,b)=>b[1]-a[1])[0];
    const best = majority && majority[1] >= 2
      ? passing.find(c => c.size === majority[0])
      : sortBy(passing,['violationCount','maxViolation','rmsViolation','centerRms'])[0];

    return {
      best,candidates,
      votes:{corridor:corridor.size,minimax:minimax.size,balance:balance.size},
      consensus:majority ? majority[1] : 1
    };
  }

  function solveTop(profile, chart, sizes, category, fitInfo, shapes) {
    const chest = num(value(profile,['chest','bust','full_bust']));
    if (!Number.isFinite(chest)) return {error:'Chest is required for top sizing.'};

    const shoulder = num(value(profile,['shoulder_width','shoulders']));
    const height = heightToInches(value(profile,['height']));
    const torso = num(value(profile,['torso_center_back','torso_length','torso']));
    const easeRange = upperEaseRange(category,fitInfo.fit,fitInfo.confidence,shapes);
    const shoulderCorridor = shoulderRange(fitInfo.fit,fitInfo.confidence,shapes);
    const vertical = verticalRanges(category,shapes);
    const chestMode = chooseCircumferenceMode(chart,sizes,'chest',chest,easeRange);
    if (!chestMode) return {error:'Chest row could not be interpreted.'};

    const minEase = shapes.stretch && !shapes.nonStretch
      ? (CFG.physicalMinimum?.upperStretchEase ?? -1)
      : (CFG.physicalMinimum?.upperNonStretchEase ?? 1.5);

    const candidates = sizes.map(size => {
      const row = chart[size] || {};
      const garmentChest = Number.isFinite(row.chest) ? (chestMode.mode === 'double' ? row.chest*2 : row.chest) : null;
      const chestEase = Number.isFinite(garmentChest) ? garmentChest-chest : null;
      const shoulderDrop = Number.isFinite(shoulder) && Number.isFinite(row.shoulder) ? (row.shoulder-shoulder)/2 : null;
      const heightRatio = Number.isFinite(height) && Number.isFinite(row.length) ? row.length/height : null;
      const torsoCoverage = Number.isFinite(torso) && Number.isFinite(row.length) ? row.length/torso : null;

      const hard = [];
      if (Number.isFinite(chestEase) && chestEase < minEase) hard.push(`chest ease ${chestEase.toFixed(2)}" below physical minimum`);
      if (Number.isFinite(shoulder) && Number.isFinite(row.shoulder) &&
          row.shoulder-shoulder < (CFG.physicalMinimum?.shoulderNarrowLimit ?? -1)) {
        hard.push('garment shoulder materially narrower than body');
      }

      const metrics = [
        intervalMetric('chest ease (in)',chestEase,easeRange),
        intervalMetric('shoulder drop/side (in)',shoulderDrop,shoulderCorridor),
        intervalMetric('garment length / body height',heightRatio,vertical.height),
        intervalMetric('garment length / torso',torsoCoverage,vertical.torso)
      ].filter(Boolean);

      return summarizeCandidate({
        size,row,hardFail:hard.length>0,hardReasons:hard,metrics,
        garmentChest,chestEase,shoulderDrop,heightRatio,torsoCoverage
      });
    });

    const result = ensemblePick(candidates);
    if (result.error) return Object.assign(result,{easeRange,shoulderCorridor,vertical,chestMode:chestMode.mode});
    let confidence = result.consensus === 3 ? 'high' : result.consensus === 2 ? 'medium' : 'limited';
    if (result.best.metrics.length < 3 || fitInfo.confidence < .35) confidence = confidence === 'high' ? 'medium' : 'limited';

    return Object.assign(result,{confidence,easeRange,shoulderCorridor,vertical,chestMode:chestMode.mode,fitInfo,category,shapes});
  }

  function solveBottom(profile, chart, sizes, category, fitInfo, shapes) {
    const waist = num(value(profile,['waist']));
    const hips = num(value(profile,['hips','hip']));
    if (!Number.isFinite(waist) || !Number.isFinite(hips)) return {error:'Waist and Hips are required for bottom sizing.'};

    const hipTable = CFG.lowerHipEase?.[category] || CFG.lowerHipEase?.pants;
    const hipRange = blendRange(hipTable.neutral,hipTable[fitInfo.fit] || hipTable.neutral,fitInfo.confidence);
    const waistTable = CFG.waistEase || {};
    const waistRange = blendRange(waistTable.neutral,waistTable[fitInfo.fit] || waistTable.neutral,fitInfo.confidence);
    const hipMode = chooseCircumferenceMode(chart,sizes,'hips',hips,hipRange);
    if (!hipMode) return {error:'Hip row could not be interpreted.'};
    const waistMode = chooseCircumferenceMode(chart,sizes,'waist',waist,waistRange);

    const inseam = num(value(profile,['inseam']));
    const thigh = num(value(profile,['thigh']));
    const inseamRange = Number.isFinite(inseam) ? {low:inseam-1.5,high:inseam+1.5,center:inseam} : null;
    const minHip = shapes.stretch && !shapes.nonStretch
      ? (CFG.physicalMinimum?.lowerStretchHipEase ?? -.5)
      : (CFG.physicalMinimum?.lowerNonStretchHipEase ?? 1);

    const candidates = sizes.map(size => {
      const row = chart[size] || {};
      const garmentHips = Number.isFinite(row.hips) ? (hipMode.mode === 'double' ? row.hips*2 : row.hips) : null;
      const hipEase = Number.isFinite(garmentHips) ? garmentHips-hips : null;
      const garmentWaist = waistMode && Number.isFinite(row.waist) ? (waistMode.mode === 'double' ? row.waist*2 : row.waist) : null;
      const waistEase = Number.isFinite(garmentWaist) ? garmentWaist-waist : null;

      const hard = [];
      if (Number.isFinite(hipEase) && hipEase < minHip) hard.push('insufficient hip/seat clearance');
      if (!shapes.adjustableWaist && Number.isFinite(waistEase) && waistEase < -.5) hard.push('waist smaller than body');

      if (Number.isFinite(thigh) && Number.isFinite(row.thigh)) {
        const thighCirc = row.thigh < 25 ? row.thigh*2 : row.thigh;
        if (thighCirc-thigh < .5 && !shapes.stretch) hard.push('insufficient thigh clearance');
      }

      const metrics = [
        intervalMetric('hip/seat ease (in)',hipEase,hipRange),
        !shapes.adjustableWaist ? intervalMetric('waist ease (in)',waistEase,waistRange) : null,
        Number.isFinite(row.inseam) ? intervalMetric('inseam (in)',row.inseam,inseamRange) : null
      ].filter(Boolean);

      return summarizeCandidate({size,row,hardFail:hard.length>0,hardReasons:hard,metrics,garmentHips,hipEase,garmentWaist,waistEase});
    });

    const result = ensemblePick(candidates);
    if (result.error) return Object.assign(result,{hipRange,waistRange});
    let confidence = result.consensus === 3 ? 'high' : result.consensus === 2 ? 'medium' : 'limited';
    if (fitInfo.confidence < .35 || result.best.metrics.length < 2) confidence = confidence === 'high' ? 'medium' : 'limited';
    return Object.assign(result,{confidence,hipRange,waistRange,fitInfo,category,shapes});
  }

  function showDebug(root,state) {
    window.VaVoomFitDebug = state;
    if (new URLSearchParams(location.search).get('fit_debug') !== 'true') return;
    root.hidden = false;
    root.setAttribute('aria-hidden','false');
    root.classList.add('vavoom-debug-visible');
    const pre = root.querySelector('[data-vavoom-fit-debug]');
    if (!pre) return;
    pre.hidden = false;

    const p = state.profile || {};
    const lines = [
      `VaVoom Fit Debug — ${VERSION}`,'',
      `Product: ${state.product || ''}`,
      `Category: ${state.category || ''}`,
      `Fit evidence: ${state.fit || ''} | confidence=${state.fitConfidence ?? ''} | source=${state.fitSource || ''}`,
      `Profile source: ${state.profileSource || ''}`,
      `Profile: chest=${p.chest || ''}, shoulder=${p.shoulder_width || ''}, torso=${p.torso_center_back || ''}, height=${p.height || ''}`,
      '',
      `SOLVER RECOMMENDATION: ${state.recommendation || 'NONE'}`,
      `Consensus: ${state.votes ? JSON.stringify(state.votes) : 'n/a'}`,
      `Confidence: ${state.confidence || 'n/a'}`,
      `APPLICATION VERIFIED: ${state.applicationVerified ? 'YES' : 'NO'}`,
      `Selected size now: ${state.selected || 'n/a'}`,''
    ];

    if (state.error) lines.push(`ERROR: ${state.error}`,'');
    if (state.candidates) {
      lines.push('Candidates:');
      state.candidates.forEach(c => {
        lines.push(`${c.size} | ${c.hardFail ? 'HARD FAIL: '+c.hardReasons.join('; ') : 'PASS'} | violations=${c.violationCount} | max=${c.maxViolation.toFixed(3)} | rms=${c.rmsViolation.toFixed(3)} | center=${c.centerRms.toFixed(3)}`);
        c.metrics.forEach(m => lines.push(`  - ${m.name}: value=${m.value.toFixed(3)} corridor=[${m.low.toFixed(3)}, ${m.high.toFixed(3)}] center=${m.center.toFixed(3)} violation=${m.violation.toFixed(3)}`));
      });
    }
    pre.textContent = lines.join('\n');
  }

  async function initProductEngine(root) {
    if (!root || root.dataset.vavoomInitialized === VERSION) return;
    root.dataset.vavoomInitialized = VERSION;

    let profile = readBrowserProfile();
    if (!profile) profile = await readCartProfile();
    if (!profile) {
      showDebug(root,{version:VERSION,error:'Fit Profile not found.',product:root.dataset.productTitle});
      return;
    }

    const m = getMeta(root);
    const cat = categoryFromMeta(m);
    const shapes = detectShapes(m);
    const fitInfo = fitEvidence(m,cat.category);
    const chart = parseSizeGuide(root);
    if (!chart) {
      showDebug(root,{version:VERSION,error:'Size Guide table could not be parsed.',product:m.title});
      return;
    }

    const sizes = availableSizes(chart);
    if (sizes.length < 2) {
      showDebug(root,{version:VERSION,error:'Fewer than two usable sizes found.',product:m.title});
      return;
    }

    const isBottom = ['shorts','sweatpants','jeans','pants'].includes(cat.category);
    const solution = isBottom
      ? solveBottom(profile,chart,sizes,cat.category,fitInfo,shapes)
      : solveTop(profile,chart,sizes,cat.category,fitInfo,shapes);

    if (!solution.best) {
      showDebug(root,{
        version:VERSION,error:solution.error || 'No valid solution.',
        product:m.title,category:cat.category,fit:fitInfo.fit,fitConfidence:fitInfo.confidence,
        fitSource:fitInfo.source,profileSource:profile.__source,profile,candidates:solution.candidates || []
      });
      return;
    }

    root.dataset.vavoomRecommendedSize = solution.best.size;
    root.dataset.vavoomConfidence = solution.confidence;
    root.dataset.vavoomAlgorithm = VERSION;
    watchUserOverride(root);

    showDebug(root,{
      version:VERSION,product:m.title,category:cat.category,
      fit:fitInfo.fit,fitConfidence:fitInfo.confidence,fitSource:fitInfo.source,
      profileSource:profile.__source,profile,
      recommendation:solution.best.size,votes:solution.votes,confidence:solution.confidence,
      candidates:solution.candidates,applicationVerified:false,selected:selectedSize()
    });

    const application = await applyVerified(root,solution.best.size);
    root.dataset.vavoomApplied = application.ok ? 'true' : 'false';
    root.dataset.vavoomAppliedSize = application.selected || '';

    showDebug(root,{
      version:VERSION,product:m.title,category:cat.category,
      fit:fitInfo.fit,fitConfidence:fitInfo.confidence,fitSource:fitInfo.source,
      profileSource:profile.__source,profile,
      recommendation:solution.best.size,votes:solution.votes,confidence:solution.confidence,
      candidates:solution.candidates,applicationVerified:application.ok,selected:application.selected,
      attempts:application.attempts
    });

    try {
      window.dispatchEvent(new CustomEvent('vavoom:fit-recommendation',{
        detail:{
          size:solution.best.size,confidence:solution.confidence,algorithm:VERSION,
          votes:solution.votes,applied:application.ok,selectedSize:application.selected
        }
      }));
    } catch(e) {}
  }

  function boot() {
    try { initProfileForm(); } catch(e) { console.error('[VaVoom Fit] profile error',e); }
    document.querySelectorAll('[data-vavoom-size-rec]').forEach(root => {
      Promise.resolve(initProductEngine(root)).catch(e => {
        console.error('[VaVoom Fit] engine error',e);
        showDebug(root,{version:VERSION,error:String(e.stack || e.message || e),product:root.dataset.productTitle});
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  document.addEventListener('shopify:section:load',boot);
  window.addEventListener('vavoom:fit-profile-saved',() => {
    document.querySelectorAll('[data-vavoom-size-rec]').forEach(root => {
      delete root.dataset.vavoomInitialized;
      delete root.dataset.vavoomUserSizeOverride;
    });
    boot();
  });

  const observer = new MutationObserver(() => {
    if ([...document.querySelectorAll('[data-vavoom-size-rec]')].some(root => root.dataset.vavoomInitialized !== VERSION)) boot();
  });
  if (document.documentElement) observer.observe(document.documentElement,{childList:true,subtree:true});

  window.VaVoomFit = {
    version:VERSION,
    rerun() {
      document.querySelectorAll('[data-vavoom-size-rec]').forEach(root => {
        delete root.dataset.vavoomInitialized;
        delete root.dataset.vavoomUserSizeOverride;
      });
      boot();
    },
    profile() { return readBrowserProfile(); }
  };
})();
